(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  window.Wishlist = window.Wishlist || (function () {
    var STORAGE_KEY = 'shop_wishlist_v1';
    function read() { try { var raw = localStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : []; } catch (e) { return []; } }
    function write(items) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } })); } catch (e) {} }
    function has(handle) { return read().some(function (p) { return p.handle === handle; }); }
    function add(product) { var items = read(); if (!items.some(function (p) { return p.handle === product.handle; })) { items.push(product); write(items); } return items; }
    function remove(handle) { var items = read().filter(function (p) { return p.handle !== handle; }); write(items); return items; }
    function toggle(product) { if (has(product.handle)) { remove(product.handle); return false; } else { add(product); return true; } }
    return { has: has, add: add, remove: remove, toggle: toggle, all: read, count: function() { return read().length; }, STORAGE_KEY: STORAGE_KEY };
  })();

  window.syncWishlistUI = window.syncWishlistUI || function (root) {
    root = root || document;
    var handles = window.Wishlist.all().map(function (p) { return p.handle; });
    root.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var isWished = handles.indexOf(handle) !== -1;
      btn.classList.toggle('is-wishlisted', isWished);
      btn.setAttribute('aria-label', isWished ? 'Remove from wishlist' : 'Add to wishlist');
    });
  };

  window.syncWishlistCounters = window.syncWishlistCounters || function () {
    var count = window.Wishlist.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  };

  if (!window.__wishlistClickBound) {
    window.__wishlistClickBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var product = {
        handle: btn.getAttribute('data-product-handle'),
        url: btn.getAttribute('data-product-url'),
        title: btn.getAttribute('data-product-title'),
        image: btn.getAttribute('data-product-image'),
        price: btn.getAttribute('data-product-price'),
        comparePrice: btn.getAttribute('data-product-compare-price') || ''
      };
      if (!product.handle) return;
      var nowWished = window.Wishlist.toggle(product);
      btn.classList.toggle('is-wishlisted', nowWished);
      btn.setAttribute('aria-label', nowWished ? 'Remove from wishlist' : 'Add to wishlist');
      if (window.syncWishlistCounters) window.syncWishlistCounters();
      btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 250, easing: 'ease-out' });
    });

    window.addEventListener('wishlist:updated', function () {
      if (window.syncWishlistUI) window.syncWishlistUI(document);
      if (window.syncWishlistCounters) window.syncWishlistCounters();
    });

    window.addEventListener('storage', function (e) {
      if (e.key === window.Wishlist.STORAGE_KEY) {
        if (window.syncWishlistUI) window.syncWishlistUI(document);
        if (window.syncWishlistCounters) window.syncWishlistCounters();
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      if (window.syncWishlistUI) window.syncWishlistUI(document);
      if (window.syncWishlistCounters) window.syncWishlistCounters();
    });

    if (document.readyState !== 'loading') {
      if (window.syncWishlistUI) window.syncWishlistUI(document);
      if (window.syncWishlistCounters) window.syncWishlistCounters();
    }
  }

  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
              if (html.querySelector('.product-card')) {
                this.classList.add('product-recommendations--loaded');
              }
              if (typeof initRecommendationsCarousel === 'function') initRecommendationsCarousel(this);
              if (window.syncWishlistUI) window.syncWishlistUI(this);
              if (window.SPR && theme.review) {
                if (document.querySelectorAll('.shopify-product-reviews-badge').length > 0) {
                  return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                }
              }
            })
            .catch(e => { console.error(e); });
        }
        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' }).observe(this);
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }

  /* ============================================================
     CAROUSEL WITH AUTO-SLIDE + INFINITE FORWARD LOOP
     - Auto-slides on mobile always (when scrollable)
     - Auto-slides on desktop only when products overflow
     - Loops forward: last page → first page (never reverses)
     ============================================================ */
  function initRecommendationsCarousel(container) {
    var root = container || document;
    var carousel = root.querySelector('[data-recommendations-carousel]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var wrapper = root.querySelector('.product-recommendations__carousel-wrapper');
    var dotsContainer = root.querySelector('[data-carousel-dots]');
    if (!carousel || !prevBtn || !nextBtn) return;

    if (carousel.dataset.carouselInit === 'true') return;
    carousel.dataset.carouselInit = 'true';

    var AUTO_SLIDE_INTERVAL = 3500; // ms between auto-slides
    var autoTimer = null;
    var isPaused = false;
    var isJumping = false;

    var realCardCount = carousel.querySelectorAll('.product-card').length;
    var originalCards = Array.prototype.slice.call(carousel.querySelectorAll('.product-card'));

    /* ---- 1. CLONE CARDS FOR INFINITE LOOP (forward only) ---- */
    function buildClones() {
      if (realCardCount === 0) return;
      // Clone the full set once, append at end (so scrolling forward always
      // has content to show, and we can silently jump back).
      var fragment = document.createDocumentFragment();
      originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-carousel-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        // Make cloned cards non-focusable / non-interactive for a11y
        clone.querySelectorAll('a, button, input, select').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        fragment.appendChild(clone);
      });
      carousel.appendChild(fragment);
    }

    /* ---- 2. VISIBLE COUNT ---- */
    function getVisibleCount() {
      var dataCount = parseInt(carousel.getAttribute('data-count'), 10) || 5;
      var width = window.innerWidth;
      var maxDesktop = 5;
      if (width >= 1200) maxDesktop = 5;
      else if (width >= 990) maxDesktop = 4;
      else if (width >= 750) maxDesktop = 3;
      else maxDesktop = 2;
      return Math.min(dataCount, maxDesktop);
    }

    /* ---- 3. SCROLL AMOUNT (one page) ---- */
    function getScrollAmount() {
      var cards = carousel.querySelectorAll('.product-card');
      if (!cards.length) return 300;
      var count = getVisibleCount();
      var gap = parseFloat(getComputedStyle(carousel).gap) || 24;
      var total = 0;
      for (var i = 0; i < count && i < cards.length; i++) {
        total += cards[i].offsetWidth;
        if (i < count - 1) total += gap;
      }
      total += gap;
      return total;
    }

    /* ---- 4. TOTAL WIDTH OF ORIGINAL SET (used for loop jump) ---- */
    function getOriginalSetWidth() {
      var cards = carousel.querySelectorAll('.product-card');
      if (!cards.length || realCardCount === 0) return 0;
      var gap = parseFloat(getComputedStyle(carousel).gap) || 24;
      var total = 0;
      for (var i = 0; i < realCardCount && i < cards.length; i++) {
        total += cards[i].offsetWidth;
        total += gap;
      }
      return total;
    }

    /* ---- 5. INFINITE LOOP JUMP ---- */
    // We cloned one full set at the end. When the user scrolls into the clone
    // region (i.e. past the original set), we silently jump back by
    // `originalSetWidth` so it looks like it loops.
    function handleLoopJump() {
      if (isJumping) return;
      var originalWidth = getOriginalSetWidth();
      if (originalWidth <= 0) return;
      var current = carousel.scrollLeft;
      // If we've scrolled past the original set, jump back
      if (current >= originalWidth - 1) {
        isJumping = true;
        var newPos = current - originalWidth;
        // Temporarily disable smooth scroll so the jump is instant
        var prevBehavior = carousel.style.scrollBehavior;
        carousel.style.scrollBehavior = 'auto';
        carousel.scrollLeft = newPos;
        carousel.style.scrollBehavior = prevBehavior || '';
        // Wait a frame, then re-enable
        requestAnimationFrame(function () {
          setTimeout(function () { isJumping = false; }, 30);
        });
      }
      // If user scrolled before the start (e.g. via prev button), jump forward
      else if (current < 0) {
        isJumping = true;
        var forwardPos = current + originalWidth;
        var prevBehavior2 = carousel.style.scrollBehavior;
        carousel.style.scrollBehavior = 'auto';
        carousel.scrollLeft = forwardPos;
        carousel.style.scrollBehavior = prevBehavior2 || '';
        requestAnimationFrame(function () {
          setTimeout(function () { isJumping = false; }, 30);
        });
      }
    }

    /* ---- 6. AUTO SLIDE ---- */
    function isScrollable() {
      return carousel.scrollWidth - carousel.clientWidth > 5;
    }

    function startAutoSlide() {
      stopAutoSlide();
      if (!isScrollable()) return;
      autoTimer = setInterval(function () {
        if (isPaused || isJumping) return;
        if (!isScrollable()) { stopAutoSlide(); return; }
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        var current = carousel.scrollLeft;
        // If we're near the end of the cloned set, jump back first
        var originalWidth = getOriginalSetWidth();
        if (originalWidth > 0 && current >= originalWidth - 5) {
          // Instant jump back to the equivalent position in the original set
          var prevBehavior = carousel.style.scrollBehavior;
          carousel.style.scrollBehavior = 'auto';
          carousel.scrollLeft = current - originalWidth;
          carousel.style.scrollBehavior = prevBehavior || '';
          // Then animate forward one page
          requestAnimationFrame(function () {
            carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          });
          return;
        }
        carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      }, AUTO_SLIDE_INTERVAL);
    }

    function stopAutoSlide() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    /* ---- 7. DOTS ---- */
    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      var visible = getVisibleCount();
      var totalPages = Math.ceil(realCardCount / visible);
      if (totalPages <= 1) return;
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-recommendations__dot';
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.dataset.page = i;
        dot.addEventListener('click', (function (page) {
          return function () {
            var cards = carousel.querySelectorAll('.product-card');
            var visible = getVisibleCount();
            var targetIndex = page * visible;
            if (targetIndex >= realCardCount) targetIndex = realCardCount - 1;
            var targetCard = cards[targetIndex];
            if (targetCard) {
              var prevBehavior = carousel.style.scrollBehavior;
              carousel.style.scrollBehavior = 'smooth';
              carousel.scrollTo({ left: targetCard.offsetLeft - carousel.offsetLeft, behavior: 'smooth' });
            }
            // Reset auto timer after manual click
            if (isScrollable()) startAutoSlide();
          };
        })(i));
        dotsContainer.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.product-recommendations__dot');
      if (!dots.length) return;
      var visible = getVisibleCount();
      var originalWidth = getOriginalSetWidth();
      var scrollLeft = carousel.scrollLeft;
      // Map scrollLeft back into original set range
      if (originalWidth > 0) {
        scrollLeft = scrollLeft % originalWidth;
      }
      var activePage = 0;
      var cards = carousel.querySelectorAll('.product-card');
      for (var i = 0; i < realCardCount && i < cards.length; i++) {
        var cardLeft = cards[i].offsetLeft - carousel.offsetLeft;
        if (cardLeft <= scrollLeft + 5) {
          activePage = Math.floor(i / visible);
        } else {
          break;
        }
      }
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === activePage);
      });
    }

    /* ---- 8. BUTTONS ---- */
    function updateButtons() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;
      var isScroll = maxScroll > 5;
      if (wrapper) {
        wrapper.setAttribute('data-scrollable', isScroll ? 'true' : 'false');
      }
      // With infinite clones, prev/next are never truly disabled.
      // Only disable when the carousel isn't scrollable at all.
      prevBtn.disabled = !isScroll;
      nextBtn.disabled = !isScroll;
    }

    prevBtn.addEventListener('click', function () {
      var originalWidth = getOriginalSetWidth();
      var current = carousel.scrollLeft;
      // If near the very start, jump to the equivalent position in the clone set
      if (current <= 1 && originalWidth > 0) {
        var prevBehavior = carousel.style.scrollBehavior;
        carousel.style.scrollBehavior = 'auto';
        carousel.scrollLeft = current + originalWidth;
        carousel.style.scrollBehavior = prevBehavior || '';
      }
      carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      if (isScrollable()) startAutoSlide();
    });

    nextBtn.addEventListener('click', function () {
      carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      if (isScrollable()) startAutoSlide();
    });

    /* ---- 9. SCROLL / LOOP LISTENER ---- */
    var rafId;
    carousel.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        handleLoopJump();
        updateButtons();
        updateDots();
      });
    }, { passive: true });

    /* ---- 10. PAUSE ON INTERACTION ---- */
    carousel.addEventListener('mouseenter', function () { isPaused = true; });
    carousel.addEventListener('mouseleave', function () { isPaused = false; });
    carousel.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
    carousel.addEventListener('touchend', function () {
      // Small delay so the user's swipe settles before resuming
      setTimeout(function () { isPaused = false; }, 1500);
    }, { passive: true });

    /* ---- 11. RESIZE ---- */
    window.addEventListener('resize', function () {
      buildDots();
      updateButtons();
      if (isScrollable()) startAutoSlide(); else stopAutoSlide();
    });

    /* ---- 12. INIT ---- */
    buildClones();
    buildDots();
    updateButtons();
    // Ensure scroll position starts at the real set (not in a clone)
    carousel.scrollLeft = 0;

    setTimeout(function () {
      buildDots();
      updateButtons();
      startAutoSlide();
    }, 300);
    setTimeout(function () {
      buildDots();
      updateButtons();
      if (isScrollable()) startAutoSlide();
    }, 800);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-recommendations').forEach(function (el) { initRecommendationsCarousel(el); });
  });

  if (document.readyState !== 'loading') {
    document.querySelectorAll('product-recommendations').forEach(function (el) { initRecommendationsCarousel(el); });
  }

  if (typeof window.openCartDrawer !== 'function') {
    window.openCartDrawer = function () {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      var possibleTriggers = ['[data-cart-drawer-toggle]', '.cart-drawer-toggle', '.js-cart-drawer-toggle', '.header__cart-toggle', '.cart-icon', '#cart-icon-bubble', '.site-header__cart', '.cart-link', '.js-drawer-open-cart', '[data-cart-toggle]', 'a[href="/cart"]'];
      for (var i = 0; i < possibleTriggers.length; i++) {
        var el = document.querySelector(possibleTriggers[i]);
        if (el) { el.click(); return true; }
      }
      if (typeof window.theme !== 'undefined' && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
        window.theme.cartDrawer.open(); return true;
      }
      window.location.href = '/cart';
      return false;
    };
  }

  if (!window.__variantPanelBound) {
    window.__variantPanelBound = true;

    document.addEventListener('click', function (e) {
      var clickedPanel = e.target.closest('.variant-panel');
      var clickedBtn = e.target.closest('.btn-add-to-cart[data-has-variants="true"]');
      if (!clickedPanel && !clickedBtn) {
        document.querySelectorAll('.variant-panel.panel-open').forEach(function (panel) { panel.classList.remove('panel-open'); });
      }
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-add-to-cart[data-has-variants="true"]');
      if (!btn) return;
      if (btn.classList.contains('sold-out')) return;
      var wrapper = btn.closest('.variant-btn-wrapper');
      if (!wrapper) return;
      var panel = wrapper.querySelector('.variant-panel');
      if (!panel) return;
      if (btn.dataset.variantId && btn.dataset.variantId !== '') return;
      e.stopPropagation();
      e.preventDefault();
      var isOpen = panel.classList.contains('panel-open');
      document.querySelectorAll('.variant-panel.panel-open').forEach(function (p) { if (p !== panel) p.classList.remove('panel-open'); });
      if (isOpen) panel.classList.remove('panel-open'); else panel.classList.add('panel-open');
    });

    document.addEventListener('click', function (e) {
      var option = e.target.closest('.variant-option');
      if (!option) return;
      if (option.classList.contains('option-unavailable')) return;
      var panel = option.closest('.variant-panel');
      if (!panel) return;
      var wrapper = panel.closest('.variant-btn-wrapper');
      if (!wrapper) return;
      var btn = wrapper.querySelector('.btn-add-to-cart');
      if (!btn) return;
      var card = btn.closest('.product-card');
      if (!card) return;
      var variantId = option.dataset.variantId;
      var variantTitle = option.dataset.title;
      var variantPrice = option.dataset.price;
      var variantComparePrice = option.dataset.comparePrice;
      var variantAvailable = option.dataset.available === 'true';
      btn.dataset.variantId = variantId;
      btn.classList.add('variant-selected');
      btn.textContent = variantTitle + ' - ' + variantPrice;
      var currentPriceEl = card.querySelector('.price-regular, .price-sale');
      var comparePriceEl = card.querySelector('.price-compare');
      if (currentPriceEl && variantPrice) currentPriceEl.textContent = variantPrice;
      if (comparePriceEl) {
        if (variantComparePrice) { comparePriceEl.textContent = variantComparePrice; comparePriceEl.style.display = ''; }
        else { comparePriceEl.style.display = 'none'; }
      }
      if (!variantAvailable) { btn.classList.add('sold-out'); btn.disabled = true; }
      else { btn.classList.remove('sold-out'); btn.disabled = false; }
      panel.classList.remove('panel-open');
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-add-to-cart[data-has-variants="true"]');
      if (!btn) return;
      if (!btn.dataset.variantId || btn.dataset.variantId === '') return;
      if (btn.classList.contains('sold-out') || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) { if (!response.ok) throw new Error('Add to cart failed'); return response.json(); })
        .then(function () {
          btn.textContent = 'Added!';
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1200);
          if (window.openCartDrawer) window.openCartDrawer();
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          btn.textContent = originalText;
          btn.disabled = false;
          alert('Could not add to cart. Please try again.');
        });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-add-to-cart-form]')) return;
      e.preventDefault();
      var button = form.querySelector('.btn-add-to-cart');
      var originalText = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Adding...'; }
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(formData).toString()
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (err) { throw err; });
          return response.json();
        })
        .then(function () {
          if (button) { button.disabled = false; button.textContent = originalText; }
          if (window.openCartDrawer) window.openCartDrawer();
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          if (button) { button.disabled = false; button.textContent = originalText; }
          alert('Could not add to cart. Please try again.');
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
